// extracted by mini-css-extract-plugin
export default {"home":"MonthStatistic_home__CUKXR"};